import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { COMMIT, COMMITALL, REPO, HISTORYALL } from "../../services/actions";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Card, Typography } from "@mui/material";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import { isBase64Image } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import FileUploader from "./FileUpload";
import axios from "axios";

export default function Documents() {
  let dispatch = useDispatch()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const backUrl = params.get("back")
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let { id } = useParams()

  let commitallState = useSelector((state) => state?.commitallState)
  let repoState = useSelector((state) => state?.repoState)

  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchDocs = (id = 0, page = 0) => {
    // const url = page === 0 ? `repo/commit/${page}/` : `commit/?page=${page}`;// pass page number    
    const url = page === 0 ? `repo/documents/${id}/` : `repo/documents/${id}/?page=${page}`;// pass page number    
    dispatch({ type: `${COMMITALL}_GET`, payload: url });
  }

  const fetchRepos = (id = 0) => {
    dispatch({ type: `${REPO}_GET`, payload: `repo/${id}/` });
  }

  React.useEffect(() => {
    try {
      fetchDocs(id, 0);
      fetchRepos(id)
    } catch (err) {
    }
  }, [id])


  React.useEffect(() => {
    try {
      if (!open) {
        fetchDocs(id, 0);
      }
    } catch (err) {
    }
  }, [open])

  React.useEffect(() => {
    fetchDocs(id, page);
  }, [page]);


  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `project/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${COMMITALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = commitallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,


  }));

  const handleDelete = (id) => {
    dispatch({ type: `${COMMIT}_DELETE`, payload: id });
  };

  const downloadFile = async (repoId, commitId) => {

    const response = await axios.get(
      `/download/${repoId}?commit_id=${commitId}`,
      {
        responseType: "blob"
      }
    );

    const disposition = response.headers["content-disposition"];

    let filename = commitId;

    if (disposition) {
      const match = disposition.match(/filename="(.+)"/);
      if (match) filename = match[1];
    }

    const blob = new Blob([response.data], {
      type: response.headers["content-type"]
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);
  };

  const getHistory = (docId) => {
    let url = `file_history/${docId}/`
    dispatch({
      type: `${HISTORYALL}_GET`, payload: url, callback: (res) => {
        console.log(res)
        navigate(`/history/`, {
          state: {
            data: res,
            prevNav: `/repository/documents/1?back=${backUrl}`
          }
        });
      }
    });
  }

  return (
    <>

      {open ? <FileUploader
        commit={defV}
        back={() => { setOpen(false) }}
      />
        : <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={user.permissions.includes('commit.add_commit')}
            label="Documents"
            setOpen={(s) => {
              setDefV({});
              setOpen(true);

            }}
            btnLabel="ADD REPOSITORY" />
          <SearchBar bylist={["project_name"]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              <Box sx={{ p: 1, mb: 2, borderRadius: "5px", backgroundColor: "#98e1f1ff", display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                <Typography >{repoState?.data?.client_id} / Documents</Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Box onClick={() => { setDefV(repoState?.data); setOpen(true) }} className={'btn-primary'} sx={{ p: 5, border: "1px solid #ccc", borderRadius: "5px" }}>
                    Upload New Document
                  </Box>
                  <Typography className="btn-primary" onClick={() => { navigate(backUrl) }} sx={{ cursor: "pointer" }}>Back →</Typography>
                </Box>

              </Box>
              <Grid container spacing={1}>
                {commitallState?.data?.results?.length === 0 && (
                  <Box sx={{ p: 2, textAlign: "center", width: 1 }}>
                    No Documents Found
                  </Box>
                )}
                {commitallState?.data?.results?.map((data, i) => {

                  return <Grid size={{ md: 6, xs: 12 }}>
                    <Card sx={{ border: "1px solid #ccc", borderRadius: "5px" }}>

                      <Box sx={{ p: 2, backgroundColor: "#f5f5f5", fontWeight: 800 }}>
                        {data.original_filename}
                      </Box>
                      <Box sx={{ p: 1, }} >{data.base_commit} </Box>
                      <Box sx={{ p: 1, }} >{data.commit_message} </Box>
                      <Box sx={{ p: 1, }} >📁 {data.repo_name} </Box>

                      <Box sx={{ p: 1 }}>📅 Created on {data.created_at?.split("T")[0]} </Box>

                      <Box sx={{ p: 1 }}>
                        <hr />
                      </Box>
                      <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box
                          onClick={() => { downloadFile(data.id, data.base_commit) }}
                          sx={{ p: 1, fontSize: 12, border: "1px solid #ccc", borderRadius: "5px" }}>
                          Download Last Version
                        </Box>
                        <Box onClick={() => { setDefV(data); setOpen(true) }}
                          className={'btn-primary'} sx={{ p: 1, border: "1px solid #ccc", borderRadius: "5px" }}>
                          Upload Updated Document
                        </Box>
                        <Box onClick={() => { getHistory(data.id) }}
                          className={'btn-primary'} sx={{ p: 1, border: "1px solid #ccc", borderRadius: "5px" }}>
                          History
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                })}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(commitallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = commitallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}